import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import { TEt3TextInput } from "../../../TypesNEW";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Et3InputField from "./InputField";
import {
  isDefinedString,
  isNullOrUndefined,
  isPositiveNumber
} from "et3-type-guards";

const Et3TextInput = withLiteObserverAndTheme<TEt3TextInput>((props) => {
  const {
    id,
    placeHolder,
    label,
    icon,
    theme,
    onChoose,
    onBlur,
    type,
    value,
    style,
    withShadow,
    onEnter,
    size
  } = props;
  const { colors, unitX, unitY, getFontSize } = theme;
  const valueEdited =
    type === "number"
      ? !isPositiveNumber(value)
        ? placeHolder
        : value
      : value;
  const isExtraSmallWidth = size === "EXTRA_SMALL";
  const isSmallWidth = size === "SMALL";
  const isMediumWidth = size === "MEDIUM";
  const isMediumPlusWidth = size === "MEDIUM_PLUS";
  const isLargeWidth = size === "LARGE";

  const width = isExtraSmallWidth
    ? 100
    : isSmallWidth
      ? 200
      : isMediumWidth
        ? 280
        : isMediumPlusWidth
          ? 450
          : isLargeWidth
            ? 1020
            : 1200;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="flex-start"
      withShadow={false}
      width={width}
      height={0}
      color={colors.all.transparent}
      style={{
        minHeight: isDefinedString(label) ? 75 * unitY : 45 * unitY,
        height: isDefinedString(label) ? 75 * unitY : 45 * unitY,
        ...style
      }}
      onClick={() => {}}
    >
      {!isDefinedString(label) ? null : (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={300}
          height={30}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={18}
            text={label}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{
              height: 18 * unitY,
              paddingTop: 0
            }}
          />
        </ET3Div>
      )}

      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={withShadow}
        width={width}
        height={45}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.white}
        style={{
          borderRadius: 39 * unitX,
          overflow: "hidden"
        }}
        onClick={() => {}}
      >
        <Et3InputField
          id={id}
          type={type}
          fieldClassName="input-placeholder"
          label={placeHolder}
          value={valueEdited}
          onChoose={onChoose}
          onBlur={onBlur}
          style={{
            border: 0,
            width: isSmallWidth
              ? "80%"
              : isMediumWidth
                ? "85%"
                : isMediumPlusWidth
                  ? "90%"
                  : "95%",
            fontSize: getFontSize(18)
          }}
          onEnter={onEnter}
        />
        {isNullOrUndefined(icon) && isExtraSmallWidth ? null : (
          <FontAwesomeIcon
            icon={icon}
            color={colors.all.bondiBlue}
            style={{
              width: 18 * unitX,
              height: 18 * unitY
            }}
          />
        )}
      </ET3Div>
    </ET3Div>
  );
});
export default Et3TextInput;
